import React from 'react';
import { Card, CardContent } from '../../../shared/components/ui';

export function ProFeatureTeaser({ feature = 'analytics' }) {
  const features = {
    analytics: {
      title: 'Unlock Pricing Analytics',
      description: 'See trends, win rates, and margin optimization insights.',
      icon: (
        <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
    confidence: {
      title: 'Advanced Confidence Analytics',
      description: 'Understand why confidence scores vary and how to improve them.',
      icon: (
        <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
    },
    guardrails: {
      title: 'Pricing Guardrails',
      description: 'Set min/max bounds and get alerts when quotes fall outside your targets.',
      icon: (
        <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      ),
    },
  };

  const featureData = features[feature] || features.analytics;

  return (
    <Card className="border-purple-200 dark:border-purple-800 bg-gradient-to-br from-purple-50 to-white dark:from-purple-900/20 dark:to-gray-900 overflow-hidden relative">
      <CardContent className="p-6">
        {/* Blurred overlay effect */}
        <div className="absolute inset-0 bg-white/60 dark:bg-gray-900/60 backdrop-blur-[1px]" />

        {/* Content */}
        <div className="relative z-10 flex items-center gap-4">
          <div className="flex-shrink-0 p-3 bg-purple-100 dark:bg-purple-900/40 rounded-lg">
            {featureData.icon}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{featureData.title}</h3>
              <span className="px-2 py-0.5 text-xs font-medium bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300 rounded-full">
                Pro
              </span>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{featureData.description}</p>
          </div>
          <button className="flex-shrink-0 px-4 py-2 text-sm font-medium text-purple-700 dark:text-purple-300 bg-purple-100 dark:bg-purple-900/40 rounded-lg hover:bg-purple-200 transition-colors">
            Learn More
          </button>
        </div>
      </CardContent>
    </Card>
  );
}

export function ConfidenceProTeaser() {
  return (
    <div className="mt-4 p-3 bg-purple-50 dark:bg-purple-900/30 border border-purple-200 dark:border-purple-800 rounded-lg">
      <div className="flex items-center gap-2">
        <svg className="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span className="text-xs text-purple-700 dark:text-purple-300">
          Advanced confidence analytics available in <span className="font-semibold">Pro</span>
        </span>
      </div>
    </div>
  );
}

export default ProFeatureTeaser;
